<template>
  <!-- eslint-disable -->
  <div>
    <ModalVerDetalle ref="modalverdetalle" />

    <div class="navbar-wrapper">
      <nav class="medical-navbar">
        <!-- Navegación adaptativa -->
        <div>
          <!-- Mobile SideNav -->
          <SideNavMobile v-if="window.width <= 1200" />

          <!-- Hamburger Menu para tablet y desktop -->
          <!-- <div v-else class="desktop-hamburger-wrapper">
            <button class="hamburger-button" @click="CambiarMenuAction()" :class="{ active: sideMenu }">
              <div class="hamburger-lines">
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
              </div>
            </button>
          </div>  -->
        </div>  

        <!-- Actions Section -->
        <div class="navbar-actions">
          <!-- Notifications -->
          <!-- Notifications -->
          <div class="notification-container">
            <button class="notification-button" aria-label="Ver notificaciones" @click.stop="toggleNotificationsMenu">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                  stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                  stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <div v-if="totalNotifications !== 0" class="notification-badge"
                :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                {{ totalNotifications > 99 ? '99+' : totalNotifications }}
              </div>
            </button>

            <!-- Notifications Dropdown -->
            <div v-if="notificationsMenu" class="notifications-dropdown" @click.stop>
              <div class="dropdown-header">
                <div class="dropdown-title">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                      :fill="prestador.admin.assets.colors.primary" />
                  </svg>
                  <span>Notificaciones</span>
                </div>
                <div class="notification-count">{{ totalNotifications }}</div>
              </div>

              <div class="dropdown-content">
                <!-- Notification Filter Bar -->
                <div v-if="showFilterBar" class="filter-bar">
                  <div class="filter-label">Filtrar por:</div>
                  <div class="filter-options">
                    <button 
                      v-for="p in availableProviders" 
                      :key="'filter-' + p.id"
                      class="filter-badge"
                      :class="{ active: selectedProviders.includes(p.id) }"
                      :style="{ 
                        '--provider-color': p.color,
                        'border-color': selectedProviders.includes(p.id) ? p.color : '#e2e8f0',
                        'background-color': selectedProviders.includes(p.id) ? p.color + '15' : 'transparent',
                        'color': selectedProviders.includes(p.id) ? p.color : '#64748b'
                      }"
                      @click="toggleProviderFilter(p.id)"
                    >
                      {{ p.nombre }}
                    </button>
                    <button v-if="selectedProviders.length > 0" class="filter-clear" @click="clearFilters">
                      Limpiar
                    </button>
                  </div>
                </div>

                <!-- Duplicated RUT Notifications -->
                <div v-if="filteredNotificaciones.duplicated_rut && filteredNotificaciones.duplicated_rut.length > 0"
                  class="notification-section">
                  <div class="section-header">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="#f59e0b" />
                    </svg>
                    <span>RUTs Duplicados</span>
                  </div>
                  <div v-for="n in filteredNotificaciones.duplicated_rut" :key="'rut-' + n.rut"
                    class="notification-item">
                    <div class="notification-content">
                      <div class="notification-title" @click="openCompare('rut', n.rut, n.orders)">RUT {{ n.rut }}
                        duplicado</div>
                      <button class="order-meta-tag" :style="{ backgroundColor: prestador.admin.assets.colors.primary }"
                        @click="openCompare('rut', n.rut, n.orders)">Comparar</button>
                      <div class="notification-details">
                        <div v-for="o in n.orders" :key="o.id" class="order-detail">
                          <div class="order-line" @click="goto_receta(o.id)">Atención #{{ o.id }} - {{ formatDate(o.fecha)
                          }}</div>
                          <div class="order-meta-tag" :style="{ backgroundColor: getPrestador(o.pid).color }">
                            <div class="order-meta">{{ getPrestador(o.pid).nombre }}</div>
                          </div>
                          <button class="order-close" aria-label="Descartar notificación"
                            @click.stop="dismissOrder(o.id)">×</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Duplicated Direccion Notifications -->
                <div
                  v-if="filteredNotificaciones.duplicated_direccion && filteredNotificaciones.duplicated_direccion.length > 0"
                  class="notification-section">
                  <div class="section-header">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.3639 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
                        stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                        stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>Direcciones Duplicadas</span>
                  </div>
                  <div v-for="n in filteredNotificaciones.duplicated_direccion" :key="'direccion-' + n.direccion"
                    class="notification-item">
                    <div class="notification-content">
                      <div class="notification-title" @click="openCompare('direccion', n.direccion, n.orders)">{{
                        n.direccion }}</div>
                      <button class="order-meta-tag" :style="{ backgroundColor: prestador.admin.assets.colors.primary }"
                        @click="openCompare('direccion', n.direccion, n.orders)">Comparar</button>
                      <div class="notification-details">
                        <div v-for="o in n.orders" :key="o.id" class="order-detail">
                          <div class="order-line" @click="goto_receta(o.id)">Atención #{{ o.id }} - {{ formatDate(o.fecha)
                          }}</div>
                          <div class="order-meta-tag" :style="{ backgroundColor: getPrestador(o.pid).color }">
                            <div class="order-meta">{{ getPrestador(o.pid).nombre }}</div>
                          </div>
                          <button class="order-close" aria-label="Descartar notificación"
                            @click.stop="dismissOrder(o.id)">×</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- No Notifications -->
                <div v-if="totalNotifications === 0" class="no-notifications">
                  <div class="no-notifications-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                        stroke="#cbd5e1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <div class="no-notifications-text">
                    <h4>Todo al día</h4>
                    <p>No hay nuevas notificaciones</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sobrecupos Section -->
          <div class="notification-container">
            <button class="notification-button" aria-label="Ver Sobrecupos" @click.stop="toggleOverbookingMenu">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none"
                stroke="#64748b" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                <path d="M6 21v-2a4 4 0 0 1 4 -4h4c.348 0 .686 .045 1.008 .128" />
                <path d="M19 16v3" />
                <path d="M19 22v.01" />
              </svg>
              <div v-if="totalOverbooking !== 0" class="notification-badge"
                :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                {{ totalOverbooking > 99 ? '99+' : totalOverbooking }}
              </div>
            </button>

            <!-- Overbooking Dropdown -->
            <div v-if="overbookingMenu" class="notifications-dropdown" @click.stop>
              <div class="dropdown-header">
                <div class="dropdown-title">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                      :fill="prestador.admin.assets.colors.primary" />
                  </svg>
                  <span>Sobrecupos</span>
                </div>
                <div class="notification-count">{{ totalOverbooking }}</div>
              </div>

              <div class="dropdown-content">
                <!-- Provider Filter Bar (Same for Overbooking) -->
                <div v-if="availableProviders.length > 0" class="filter-bar">
                  <div class="filter-label">Filtrar por:</div>
                  <div class="filter-options">
                    <button 
                      v-for="p in availableProviders" 
                      :key="'filter-ob-' + p.id"
                      class="filter-badge"
                      :class="{ active: selectedProviders.includes(p.id) }"
                      :style="{ 
                        '--provider-color': p.color,
                        'border-color': selectedProviders.includes(p.id) ? p.color : '#e2e8f0',
                        'background-color': selectedProviders.includes(p.id) ? p.color + '15' : 'transparent',
                        'color': selectedProviders.includes(p.id) ? p.color : '#64748b'
                      }"
                      @click="toggleProviderFilter(p.id)"
                    >
                      {{ p.nombre }}
                    </button>
                    <button v-if="selectedProviders.length > 0" class="filter-clear" @click="clearFilters">
                      Limpiar
                    </button>
                  </div>
                </div>

                <div v-if="filteredNotificaciones.overbooking && filteredNotificaciones.overbooking.length > 0"
                  class="notification-section">
                  <div class="section-header">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="#f59e0b" />
                    </svg>
                    <span>Profesionales con sobrecupo</span>
                  </div>
                  <div v-for="n in filteredNotificaciones.overbooking"
                    :key="'overbooking-' + n.profesional_id + '-' + n.fecha_dia" class="notification-item">
                    <div class="notification-content">
                      <div class="notification-title" @click="openOverbookingCompare(n)">
                        {{ n.profesional_nombre }} - {{ formatDate(n.fecha_dia) }}
                      </div>
                      <div class="overbooking-meta">
                        <button class="order-meta-tag"
                          :style="{ backgroundColor: prestador.admin.assets.colors.primary }"
                          @click="openOverbookingCompare(n)">
                          Comparar {{ n.solapamientos }} solapamientos
                        </button>
                      </div>
                      <div class="notification-details">
                        <div v-for="o in n.orders" :key="o.id" class="order-detail">
                          <div class="order-line" @click="goto_receta(o.id)">
                            Atención #{{ o.id }}
                          </div>
                          <div class="order-meta-tag" :style="{ backgroundColor: getPrestador(o.pid).color }">
                            <div class="order-meta">{{ getPrestador(o.pid).nombre }}</div>
                          </div>
                          <div class="order-status" :class="getStatusClass(o.estado)">
                            {{ o.horario_str }}
                          </div>
                          <button class="order-close" aria-label="Descartar notificación"
                            @click.stop="dismissOrder(o.id)">×</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- No Overbooking Notifications -->
                <div v-if="totalOverbooking === 0" class="no-notifications">
                  <div class="no-notifications-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                        stroke="#cbd5e1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <div class="no-notifications-text">
                    <h4>Todo al día</h4>
                    <p>No hay nuevas notificaciones de sobrecupos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <!-- Compare Modal -->
          <div v-if="compareModalOpen" class="compare-modal-backdrop" @click.self="closeCompare">
            <div class="compare-modal">
              <div class="compare-header">
                <h3 v-if="compareGroupType === 'rut'">RUT {{ compareGroupTitle }} duplicado</h3>
                <h3 v-else>Dirección: {{ compareGroupTitle }}</h3>
                <button class="compare-close" @click="closeCompare" aria-label="Cerrar">×</button>
              </div>
              <div class="compare-body">
                <div v-for="o in compareGroupOrders" :key="o.id" class="compare-row">
                  <div class="compare-left">
                    <div class="order-line">Orden #{{ o.id }} - {{ formatDate(o.fecha) }}</div>
                  </div>
                  <!-- <div class="compare-right">
                   
                    <button class="compare-open" @click="goto_receta(o.id)">Ver</button>
                  </div> -->
                  <!-- <div class="compare-right">
                        <button class="order-meta-tag" :style="{ backgroundColor: getPrestador(o.pid).color }" @click="enviar_confirmacion(o.id)">Enviar confirmación</button>
                  </div> -->
                  <div class="compare-details">
                    <div v-if="orderDetailsLoading[keyFor(o)]">Cargando...</div>
                    <div v-else-if="orderDetails[keyFor(o)]">
                      <div class="order-meta-tag" :style="{ backgroundColor: getPrestador(o.pid).color }">
                        <div class="order-meta">{{ getPrestador(o.pid).nombre }}</div>
                      </div>
                      <div class="details-grid">
                        <div><strong>Cliente:</strong> {{ ((orderDetails[keyFor(o)].clientes &&
                          orderDetails[keyFor(o)].clientes[0]) ? (orderDetails[keyFor(o)].clientes[0].nombre + ' ' +
                            (orderDetails[keyFor(o)].clientes[0].apellido1 || '')) : (orderDetails[keyFor(o)].nombre ||
                              '-')) || '-' }}</div>
                        <div><strong>RUT:</strong> {{ ((orderDetails[keyFor(o)].clientes &&
                          orderDetails[keyFor(o)].clientes[0]) ? (orderDetails[keyFor(o)].clientes[0].rut || '-') : '-')
                        }}</div>
                        <div><strong>Teléfono:</strong> {{ orderDetails[keyFor(o)].telefono || '-' }}</div>
                        <div><strong>Dirección:</strong> {{ orderDetails[keyFor(o)].direccion || '-' }}</div>
                        <div><strong>Fecha:</strong> {{ formatDate(orderDetails[keyFor(o)].fecha) }}</div>
                        <div><strong>Profesional:</strong> {{ (orderDetails[keyFor(o)].profesional ?
                          ((orderDetails[keyFor(o)].profesional.nombre || '') + ' ' +
                            (orderDetails[keyFor(o)].profesional.apellido || '')) : '-') }}</div>
                        <div><strong>Recetas:</strong> {{ (orderDetails[keyFor(o)].recetas ?
                          orderDetails[keyFor(o)].recetas.length : 0) }}</div>
                        <div><strong>Examen:</strong> {{ (orderDetails[keyFor(o)].examenes &&
                          orderDetails[keyFor(o)].examenes[0] ? (orderDetails[keyFor(o)].examenes[0].nombre || '-') :
                          '-') }}</div>
                      </div>
                      <details class="details-raw">
                        <summary>Más Detalles</summary>
                        <div>
                          <ul>
                            <li>Nacionalidad: {{ (orderDetails[keyFor(o)].clientes &&
                              orderDetails[keyFor(o)].clientes[0] && orderDetails[keyFor(o)].clientes[0].nacionalidad)
                              || '-' }}</li>
                            <li>Fecha de creación: {{ orderDetails[keyFor(o)].fecha_creado || '-' }}</li>
                            <li>Estado: {{ getStatus(orderDetails[keyFor(o)].estado) }}</li>
                          </ul>
                        </div>
                      </details>
                    </div>
                    <div v-else>Sin datos</div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- User Menu -->
          <div class="user-menu-container" @click.stop="toggleUserMenu">
            <button class="user-button">
              <div class="user-avatar"
                :style="{ 'background': 'linear-gradient(135deg, ' + prestador.admin.assets.colors.primary + ', ' + prestador.admin.assets.colors.secondary + ')' }">
                {{ admin_datos.nombre[0] }}
              </div>
              <div v-if="window.width > 1200" class="user-info">
                <span class="user-name">{{ admin_datos.nombre }}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="#64748b" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </button>

            <!-- User Dropdown Menu -->
            <div v-if="dropdownMenu && isLoggedIn" class="user-dropdown" @click.stop>
              <div v-if="!isLoggingOut" class="user-dropdown-content">
                <div class="user-profile-section">
                  <div class="user-avatar-large"
                    :style="{ 'background': 'linear-gradient(135deg, ' + prestador.admin.assets.colors.primary + ', ' + prestador.admin.assets.colors.secondary + ')' }">
                    {{ admin_datos.nombre[0] }}
                  </div>
                  <div class="user-details">
                    <div class="user-name-large">{{ admin_datos.nombre }} {{ admin_datos.apellido }}</div>
                    <div class="user-role">Administrador</div>
                  </div>
                </div>

                <div class="dropdown-divider"></div>

                <div class="dropdown-menu-items">
                  <router-link to="/PerfilAdministrador" class="dropdown-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 21V19C20 17.9391 19.5786 16.9217..." stroke="#64748b"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 11C14.2091 11 16 9.20914..." stroke="#64748b"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Mi Perfil</span>
                  </router-link>

                  <router-link to="/Configuracion" class="dropdown-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 21V19C20 17.9391..." stroke="#64748b"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 11C14.2091 11 16 9.20914..." stroke="#64748b"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Configuración</span>
                  </router-link>

                  <!-- 
                  <button class="dropdown-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.2579 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.01127 9.77251C4.28054 9.5799 4.48571 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z"
                        stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>Configuración</span>
                  </button> -->
                </div>

                <div class="dropdown-divider"></div>

                <button class="dropdown-item logout-item" @click="sendLogOut">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                      stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M16 17L21 12L16 7" stroke="#ef4444" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M21 12H9" stroke="#ef4444" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  <span>Cerrar Sesión</span>
                </button>

                <div class="dropdown-footer">
                  <div class="footer-links">
                    <a href="#" class="footer-link">Sobre ClinicGo</a>
                    <span class="footer-separator">•</span>
                    <a href="#" class="footer-link">Más información</a>
                  </div>
                </div>
              </div>

              <div v-else class="logout-loading">
                <div class="logout-loader">
                  <Loader :height="60" :width="60" />
                  <div class="logout-text">Cerrando sesión...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import '@/assets/estilo_importado/vendor/css/rtl/core.css';
import '@/assets/estilo_importado/vendor/css/rtl/theme-default.css';
import '@/assets/estilo_importado/css/demo.css';

/* Vendor css */
import '@/assets/estilo_importado/vendor/libs/node-waves/node-waves.css';
import '@/assets/estilo_importado/vendor/libs/perfect-scrollbar/perfect-scrollbar.css';
import '@/assets/estilo_importado/vendor/libs/typeahead-js/typeahead.css';

/* Icons */
import '@/assets/estilo_importado/vendor/fonts/fontawesome.css';
import '@/assets/estilo_importado/vendor/fonts/tabler-icons.css';
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import Loader from '@/components/Loader.vue';
import ModalVerDetalle from '@/components/utils/ModalVerDetalle.vue';

import SideNavMobile from './SideNavMobile.vue';

export default {
  name: 'TopNav',
  components: {
    Loader,
    ModalVerDetalle,
    SideNavMobile
  },
  data() {
    return {
      cargando_pacientes: false,
      pacientes_buscados: [],
      buscando_paciente: '',
      dropdownMenu: false,
      notificationsMenu: false,
      overbookingMenu: false,
      isLoggingOut: false,
      mostrando: false,
      cargando: false,
      dismissedOrdersMap: {},
      prevNotificationCount: 0,
      audioContext: null,
      compareModalOpen: false,
      compareGroupType: '',
      compareGroupTitle: '',
      compareGroupOrders: [],
      orderDetails: {},
      orderDetailsLoading: {},
      window: {
        width: 0,
        height: 0,
      },
      selectedProviders: [],
      allProvidersList: [
        { nombre: 'Integramédica', prestador_id: 9, color: '#0079c8' },
        { nombre: 'Clínica Alemana', prestador_id: 5, color: '#01a49a' },
        { nombre: 'Laboratorio Blanco', prestador_id: 13, color: '#5e81bc' },
        { nombre: 'UC Christus', prestador_id: 14, color: '#872899' },
        { nombre: 'ClinicGo', prestador_id: 1, color: '#1486e7' },
        { nombre: 'Dávila', prestador_id: 15, color: '#F18A00' },
        { nombre: 'UC Christus En Casa', prestador_id: 16, color: '#872899' },
        { nombre: 'UC Christus Test', prestador_id: 21, color: '#872899' },
        { nombre: 'SportsMD', prestador_id: 18, color: '#2AB042' },
        { nombre: 'Bionet', prestador_id: 3, color: '#0884f4' },
        { nombre: 'Clínica Santa Maria', prestador_id: 22, color: '#536fa6' },
        { nombre: 'Mainque', prestador_id: 2, color: '#4a29d3' },
        { nombre: 'Clini', prestador_id: 4, color: '#5b398e' },
        { nombre: 'Clic Salud', prestador_id: 6, color: '#5b398e' },
        { nombre: 'Reley', prestador_id: 6, color: '#5b398e' },
        { nombre: 'Regonesi', prestador_id: 8, color: '#008cd5' },
        { nombre: 'CardioPro', prestador_id: 11, color: '#AF0009' },
        { nombre: 'Nomad', prestador_id: 20, color: '#506C6C' },
        { nombre: 'Testing', prestador_id: 23, color: '#506C6C' },
      ]
    };
  },
  computed: {
    ...mapGetters(['admin_datos', 'isLoggedIn', 'sideMenu', 'prestador', 'notificaciones']),
    filteredNotificaciones() {
      const dismissed = this.dismissedOrdersMap || {};
      const selected = this.selectedProviders || [];
      const isFiltering = selected.length > 0;

      const result = { duplicated_rut: [], duplicated_direccion: [], overbooking: [] };

      if (this.notificaciones && Array.isArray(this.notificaciones.duplicated_rut)) {
        for (const group of this.notificaciones.duplicated_rut) {
          const nonDismissedOrders = (group.orders || []).filter(o => !dismissed[o.id]);
          const hasSelectedProvider = !isFiltering || nonDismissedOrders.some(o => selected.includes(o.pid));
          
          if (hasSelectedProvider && nonDismissedOrders.length > 0) {
            result.duplicated_rut.push({ ...group, orders: nonDismissedOrders });
          }
        }
      }

      if (this.notificaciones && Array.isArray(this.notificaciones.duplicated_direccion)) {
        for (const group of this.notificaciones.duplicated_direccion) {
          const nonDismissedOrders = (group.orders || []).filter(o => !dismissed[o.id]);
          const hasSelectedProvider = !isFiltering || nonDismissedOrders.some(o => selected.includes(o.pid));
          
          if (hasSelectedProvider && nonDismissedOrders.length > 0) {
            result.duplicated_direccion.push({ ...group, orders: nonDismissedOrders });
          }
        }
      }

      if (this.notificaciones && Array.isArray(this.notificaciones.overbooking)) {
        for (const group of this.notificaciones.overbooking) {
          const nonDismissedOrders = (group.orders || []).filter(o => !dismissed[o.id]);
          const hasSelectedProvider = !isFiltering || nonDismissedOrders.some(o => selected.includes(o.pid));
          
          if (hasSelectedProvider && nonDismissedOrders.length > 0) {
            result.overbooking.push({ ...group, orders: nonDismissedOrders });
          }
        }
      }

      return result;
    },
    availableProviders() {
      if (!this.notificaciones) return [];
      
      const isSuperAdmin = this.prestador && this.prestador.id === 1;

      if (isSuperAdmin) {
        return this.allProvidersList.map(p => ({ id: p.prestador_id, ...p }))
          .sort((a, b) => a.nombre.localeCompare(b.nombre));
      }

      const providers = new Map();
      const dismissed = this.dismissedOrdersMap || {};
      
      const processOrders = (orders) => {
        (orders || []).forEach(o => {
          if (!dismissed[o.id]) {
            const p = this.getPrestador(o.pid);
            providers.set(o.pid, { id: o.pid, ...p });
          }
        });
      };

      if (Array.isArray(this.notificaciones.duplicated_rut)) {
        this.notificaciones.duplicated_rut.forEach(g => processOrders(g.orders));
      }
      if (Array.isArray(this.notificaciones.duplicated_direccion)) {
        this.notificaciones.duplicated_direccion.forEach(g => processOrders(g.orders));
      }
      if (Array.isArray(this.notificaciones.overbooking)) {
        this.notificaciones.overbooking.forEach(g => processOrders(g.orders));
      }

      const found = Array.from(providers.values());
      return found.sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
    showFilterBar() {
      const isSuperAdmin = this.prestador && this.prestador.id === 1;
      if (isSuperAdmin) return true;
      return this.availableProviders.length > 1;
    },
    totalNotifications() {
      let count = 0;
      if (this.filteredNotificaciones.duplicated_rut) {
        count += this.filteredNotificaciones.duplicated_rut.length;
      }
      if (this.filteredNotificaciones.duplicated_direccion) {
        count += this.filteredNotificaciones.duplicated_direccion.length;
      }
      return count;
    },
    totalOverbooking() {
      return this.filteredNotificaciones.overbooking.length;
    }
  },
  watch: {
    notificaciones: {
      handler() {
        const current = this.totalNotifications;
        if (current > this.prevNotificationCount) {
          this.playNotificationSound();
        }
        this.prevNotificationCount = current;
      },
      deep: true,
      immediate: false,
    },
    buscando_paciente(val) {
      if (val.length > 7) {
        this.cargando_pacientes = true;
        axios
          .post(`${window.hostname}/api/admin/buscar_paciente`, { string_: val })
          .then((response) => {
            this.cargando_pacientes = false;
            this.pacientes_buscados = response.data.clientes;
          })
          .catch((e) => {
            if (e.response.data.message) this.resultado = e.response.data.message;
            this.cargando_pacientes = false;
          });
      }
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.loadDismissedOrders();
    this.prevNotificationCount = this.totalNotifications;
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    keyFor(o) {
      return `${o.id}-${o.pid}`;
    },
    isDetailsOpen(o) {
      return !!this.orderDetails[this.keyFor(o)] || !!this.orderDetailsLoading[this.keyFor(o)];
    },
    async toggleOrderDetails(o) {
      const key = this.keyFor(o);
      if (this.orderDetails[key]) {
        this.$delete(this.orderDetails, key);
        return;
      }
      try {
        this.$set(this.orderDetailsLoading, key, true);
        const { data } = await axios.get(`${window.hostname}/api/admin/get_orden_by_id_and_prestador`, {
          params: { orden_id: o.id, prestador_id: o.pid },
        });
        // Some backends return { orden, status } or [orden, status]. Handle both simply.
        const detalle = data?.orden || (Array.isArray(data) ? data[0] : data);
        this.$set(this.orderDetails, key, detalle || {});
      } catch (e) {
        this.$set(this.orderDetails, key, { error: true, message: e?.response?.data?.message || 'Error al cargar detalle' });
      } finally {
        this.$delete(this.orderDetailsLoading, key);
      }
    },
    pretty(obj) {
      try { return JSON.stringify(obj, null, 2); } catch (_) { return String(obj); }
    },
    getStatus(status) {
      const statusMap = {
        0: 'Anulado',
        1: 'Citado',
        2: 'Confirmado',
        3: 'En Proceso',
        4: 'Completado'
      }
      return statusMap[status] || 'Desconocido'
    },
    async openCompare(type, title, orders) {
      this.compareGroupType = type;
      this.compareGroupTitle = title;
      this.compareGroupOrders = Array.isArray(orders) ? orders : [];
      this.compareModalOpen = true;
      try {
        await Promise.all(this.compareGroupOrders.map(o => this.ensureOrderDetails(o)));
      } catch (_) { }
    },
    openOverbookingCompare(overbookingGroup) {
      this.compareGroupType = 'overbooking';
      this.compareGroupTitle = `${overbookingGroup.profesional_nombre} - ${this.formatDate(overbookingGroup.fecha_dia)}`;
      this.compareGroupOrders = overbookingGroup.orders || [];
      this.compareModalOpen = true;

      try {
        Promise.all(this.compareGroupOrders.map(o => this.ensureOrderDetails(o)));
      } catch (_) { }
    },
    formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },
    getStatusClass(status) {
      const statusClasses = {
        1: 'status-citado', // Citado
        2: 'status-confirmado', // Confirmado
        3: 'status-proceso', // En Proceso
        4: 'status-completado' // Completado
      };
      return statusClasses[status] || 'status-desconocido';
    },

    getStatusText(status) {
      const statusMap = {
        1: 'Citado',
        2: 'Confirmado',
        3: 'En Proceso',
        4: 'Completado'
      };
      return statusMap[status] || 'Desconocido';
    },

    async ensureOrderDetails(o) {
      const key = this.keyFor(o);
      if (this.orderDetails[key] || this.orderDetailsLoading[key]) return;
      try {
        this.$set(this.orderDetailsLoading, key, true);
        const { data } = await axios.get(`${window.hostname}/api/admin/get_orden_by_id_and_prestador`, {
          params: { orden_id: o.id, prestador_id: o.pid },
        });
        const detalle = data?.orden || (Array.isArray(data) ? data[0] : data);
        this.$set(this.orderDetails, key, detalle || {});
      } catch (e) {
        this.$set(this.orderDetails, key, { error: true, message: e?.response?.data?.message || 'Error al cargar detalle' });
      } finally {
        this.$delete(this.orderDetailsLoading, key);
      }
    },
    closeCompare() {
      this.compareModalOpen = false;
      this.compareGroupType = '';
      this.compareGroupTitle = '';
      this.compareGroupOrders = [];
    },
    ...mapActions(['logoutAdmin', 'CambiarMenuAction']),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    sendLogOut() {
      this.isLoggingOut = true;
      setTimeout(() => {
        this.isLoggingOut = false;
        this.logoutAdmin();
        this.$router.push({ name: 'Home' });
      }, 1500);
    },
    loadDismissedOrders() {
      try {
        const raw = localStorage.getItem('dismissed_orders');
        this.dismissedOrdersMap = raw ? JSON.parse(raw) : {};
      } catch (e) {
        this.dismissedOrdersMap = {};
      }
    },
    saveDismissedOrders() {
      try {
        localStorage.setItem('dismissed_orders', JSON.stringify(this.dismissedOrdersMap || {}));
      } catch (e) { }
    },
    dismissOrder(orderId) {
      if (!orderId) return;
      this.$set(this.dismissedOrdersMap, orderId, true);
      this.saveDismissedOrders();
    },
    playNotificationSound() {
      try {
        const ctx = this.audioContext || new (window.AudioContext || window.webkitAudioContext)();
        this.audioContext = ctx;
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = 'sine';
        o.frequency.setValueAtTime(880, ctx.currentTime);
        g.gain.setValueAtTime(0.0001, ctx.currentTime);
        g.gain.exponentialRampToValueAtTime(0.1, ctx.currentTime + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.2);
        o.connect(g).connect(ctx.destination);
        o.start();
        o.stop(ctx.currentTime + 0.22);
      } catch (e) {

      }
    },
    getPrestador(id) {
      const numericId = Number(id);
      const prestador = this.allProvidersList.find(p => p.prestador_id === numericId);
      return prestador ? prestador : { nombre: `Prestador ${id ?? '-'}`, color: '#94a3b8' };
    },
    goto_receta(pid) {
      if (!pid) return;

      this.$router.push({ path: '/VerReceta/' + pid });
    },
    enviar_confirmacion(orden_id) {
      axios.post(window.hostname + '/api/admin/enviar_correo_confirmacion',
        { orden_id: orden_id })
        .then(response => {
          this.$notify({
            group: 'foo',
            title: '¡Éxito!',
            text: '¡Se ha enviado el correo de confirmación!',
            type: 'success'
          });
          this.get_ordenes()
          this.popup = false;
        })

        .catch(e => {
          if (e.response.data.message)
            this.resultado = e.response.data.message
        })
    },
    toggleUserMenu() {
      this.dropdownMenu = !this.dropdownMenu;
    },
    toggleNotificationsMenu() {
      this.notificationsMenu = !this.notificationsMenu;
    },
    toggleOverbookingMenu() {
      this.overbookingMenu = !this.overbookingMenu;
    },
    toggleProviderFilter(providerId) {
      const index = this.selectedProviders.indexOf(providerId);
      if (index === -1) {
        this.selectedProviders.push(providerId);
      } else {
        this.selectedProviders.splice(index, 1);
      }
    },
    clearFilters() {
      this.selectedProviders = [];
    },
    close(e) {
      // Cerrar búsqueda de pacientes (tu lógica actual)
      if (!this.$el.contains(e.target)) {
        if (!e.target.classList.contains('no-cerrar')) {
          this.pacientes_buscados = [];
          this.buscando_paciente = '';
        }
      }

      // Cerrar dropdown de notificaciones si está abierto y se hizo click fuera
      if (this.notificationsMenu) {
        const notificationContainer = this.$el.querySelector('.notification-container');
        if (notificationContainer && !notificationContainer.contains(e.target)) {
          this.notificationsMenu = false;
        }
      }

      // Cerrar dropdown de sobrecupos si está abierto y se hizo click fuera
      if (this.overbookingMenu) {
        const overbookingContainer = this.$el.querySelectorAll('.notification-container')[1]; // El segundo contenedor
        if (overbookingContainer && !overbookingContainer.contains(e.target)) {
          this.overbookingMenu = false;
        }
      }

      // Cerrar dropdown de usuario si está abierto y se hizo click fuera
      if (this.dropdownMenu) {
        const userMenuContainer = this.$el.querySelector('.user-menu-container');
        if (userMenuContainer && !userMenuContainer.contains(e.target)) {
          this.dropdownMenu = false;
        }
      }
    },
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' });
    },
  },
  mounted() {
    document.addEventListener('click', this.close);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close);
  },
};
</script>



<style scoped>
/* Base Styles */
* {
  box-sizing: border-box;
}

/* Navbar Wrapper */
.navbar-wrapper {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.medical-navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  max-width: 100%;
  margin: 0 auto;
  background-color: #ffffff;
}

/* Mobile Brand Section */
.mobile-brand {
  display: flex;
  align-items: center;
  gap: 16px;
}

.mobile-logo-container {
  display: flex;
  align-items: center;
}

.logo-background {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hamburger Menu */
.hamburger-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hamburger-button:hover {
  background-color: #f1f5f9;
}

.hamburger-lines {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 20px;
  height: 16px;
}

.line {
  width: 100%;
  height: 2px;
  background-color: #64748b;
  border-radius: 1px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.hamburger-button.active .line1 {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger-button.active .line2 {
  opacity: 0;
}

.hamburger-button.active .line3 {
  transform: rotate(-45deg) translate(7px, -6px);
}

/* Search Sec/* Search Section - MODIFICADO para ser más pequeña y con menos margen */
.search-section {
  flex: 1;
  max-width: 500px;
  /* Reducido de 600px a 500px */
  margin: 0 8px 0 24px;
  /* Margen derecho reducido significativamente */
  position: relative;
}

.search-container {
  position: relative;
  width: 100%;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  /* Ligeramente menos redondeado */
  transition: all 0.2s ease;
}

.search-input-wrapper:focus-within {
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
  background-color: #ffffff;
}

.search-icon {
  position: absolute;
  left: 14px;
  /* Ajustado para barra más pequeña */
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-input {
  width: 100%;
  padding: 12px 42px 12px 46px;
  /* Reducido padding (14px -> 12px) */
  border: none;
  background: transparent;
  font-size: 0.875rem;
  color: #1f2937;
  outline: none;
}

.search-input::placeholder {
  color: #9ca3af;
}

.clear-search {
  position: absolute;
  right: 14px;
  /* Ajustado para barra más pequeña */
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.clear-search:hover {
  background-color: #f1f5f9;
}

/* Actions Section - MODIFICADO para estar pegado */
.navbar-actions {
  display: flex;
  align-items: center;
  gap: 0;
  /* Eliminado gap completamente */
  margin-left: -4px;
  /* Superposición con la barra */
}

/* Notifications - MODIFICADO para estar pegado */
.notification-container {
  position: relative;
}

.notification-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  /* Tamaño ajustado */
  height: 46px;
  /* Tamaño ajustado */
  background: none;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  margin-left: -8px;
  /* Superposición más pronunciada */
}

.notification-button:hover {
  background-color: #f1f5f9;
  transform: scale(1.05);
}

.notification-button svg {
  width: 22px;
  /* Icono ligeramente más pequeño */
  height: 22px;
}

.notification-badge {
  position: absolute;
  top: 8px;
  right: 6px;
  /* Posición ajustada */
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  /* Texto ligeramente más pequeño */
  font-weight: 600;
  color: white;
  border: 2px solid #ffffff;
}

/* El resto del CSS se mantiene igual */

.search-results-popup {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 50;
  max-height: 400px;
  overflow-y: auto;
}

.search-results-content {
  padding: 16px;
}

.results-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0 12px 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 12px;
}

.results-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.patient-result-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.patient-result-item:hover {
  background-color: #f8fafc;
}

.patient-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0ea5e9, #10b981);
  border-radius: 8px;
  flex-shrink: 0;
}

.patient-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.patient-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1f2937;
}

.patient-date {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
  color: #64748b;
}

.patient-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
}

.no-results-icon {
  margin-bottom: 16px;
  opacity: 0.5;
}

.no-results-text h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 4px 0;
}

.no-results-text p {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

.search-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  font-size: 0.875rem;
  color: #64748b;
  justify-content: center;
}

.search-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  gap: 16px;
}

.search-loading span {
  font-size: 0.875rem;
  color: #64748b;
}

/* Notifications Dropdown */
.notifications-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 380px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 50;
  max-height: 500px;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .notifications-dropdown {
    position: fixed;
    top: 70px;
    right: 10px;
    left: 10px;
    width: auto;
    max-width: calc(100% - 20px);
    max-height: 80vh;
    overflow-y: auto;
    border-radius: 12px;
  }
}

/* Ajustes para mobile */
@media (max-width: 1200px) {
  .search-section {
    max-width: 400px;
    margin: 0 4px 0 16px;
  }

  .search-input {
    padding: 10px 38px 10px 42px;
  }

  .navbar-actions {
    margin-left: -6px;
  }

  .notification-button {
    width: 42px;
    height: 42px;
    margin-left: -6px;
  }

  .notification-button svg {
    width: 20px;
    height: 20px;
  }
}

.dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.dropdown-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}

.notification-count {
  padding: 4px 8px;
  background-color: #f1f5f9;
  color: #64748b;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.dropdown-content {
  padding: 8px 0;
}

.filter-bar {
  padding: 12px 20px;
  background-color: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.filter-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid #e2e8f0;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.filter-badge:hover {
  filter: brightness(0.95);
}

.filter-badge.active {
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.filter-clear {
  padding: 4px 8px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #3b82f6;
  background: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
}

.filter-clear:hover {
  color: #2563eb;
}

.notification-section {
  margin-bottom: 16px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  background-color: #fef3c7;
  margin-bottom: 8px;
}

.notification-item {
  padding: 16px 20px;
  /* más espacio */
  border-bottom: 1px solid #f8fafc;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* más espacio entre título y detalles */
}

.notification-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #1f2937;
}

.notification-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* espacio entre órdenes */
}

.order-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  padding: 0.75rem 1rem;
  margin-bottom: 0.75rem;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.2s ease, transform 0.1s ease;
  cursor: pointer;
}

.order-detail:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.order-line {
  font-size: 0.95rem;
  font-weight: 500;
  color: #1c1c1e;
  flex: 1;
  user-select: none;
}

.order-meta-tag {
  padding: 0.25rem 0.6rem;
  border-radius: 8px;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
}

.order-meta {
  letter-spacing: 0.3px;
}

.order-close {
  background: transparent;
  border: none;
  font-size: 1.2rem;
  color: #8e8e93;
  cursor: pointer;
  padding: 0 0.25rem;
  line-height: 1;
  transition: color 0.2s ease, transform 0.1s ease;
}

.order-close:hover {
  color: #1c1c1e;
  transform: scale(1.1);
}

.order-close:focus {
  outline: none;
  color: #1c1c1e;
}

/* Compare Modal Styles */
.compare-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.compare-modal {
  width: min(720px, 95vw);
  max-height: 80vh;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.compare-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.compare-header h3 {
  margin: 0;
  font-size: 1rem;
}

.compare-close {
  background: transparent;
  border: none;
  font-size: 1.4rem;
  color: #64748b;
  cursor: pointer;
}

.compare-body {
  padding: 12px 16px;
  overflow: auto;
}

.compare-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f8fafc;
}

.compare-left {
  flex: 1;
}

.compare-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.compare-details {
  width: 100%;
  background: #f8fafc;
  border-radius: 8px;
  padding: 10px;
  margin: 8px 0 0 0;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
}

.details-pre {
  margin: 0;
  white-space: pre-wrap;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  color: #111827;
}

.compare-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.compare-open {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
}

.no-notifications {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.no-notifications-icon {
  margin-bottom: 16px;
  opacity: 0.5;
}

.no-notifications-text h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 4px 0;
}

.no-notifications-text p {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

/* User Menu */
.user-menu-container {
  position: relative;
}

.user-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  border-radius: 8px;
  padding: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.user-button:hover {
  background-color: #f1f5f9;
}

.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 4px;
}

.user-name {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}

/* User Dropdown */
.user-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 280px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 50;
}

.user-dropdown-content {
  padding: 16px 0;
}

.user-profile-section {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
}

.user-avatar-large {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  color: white;
  font-size: 1.125rem;
  font-weight: 600;
  text-transform: uppercase;
  flex-shrink: 0;
}

.user-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-name-large {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1f2937;
}

.user-role {
  font-size: 0.75rem;
  color: #64748b;
}

.dropdown-divider {
  height: 1px;
  background-color: #f1f5f9;
  margin: 8px 0;
}

.dropdown-menu-items {
  padding: 8px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 20px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  color: #374151;
}

.dropdown-item:hover {
  background-color: #f8fafc;
}

.logout-item {
  color: #ef4444;
}

.logout-item:hover {
  background-color: #fef2f2;
}

.dropdown-footer {
  padding: 12px 20px 8px 20px;
}

.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 0.75rem;
}

.footer-link {
  color: #64748b;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: #374151;
}

.footer-separator {
  color: #cbd5e1;
}

.logout-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.logout-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.logout-text {
  font-size: 0.875rem;
  color: #64748b;
}

@media (max-width: 1024px) {
  .medical-navbar {
    padding: 12px 16px;
  }

  .search-section {
    margin: 0 12px;
  }

  .search-input {
    padding: 12px 40px 12px 48px;
    font-size: 0.875rem;
  }

  .search-input::placeholder {
    font-size: 0.875rem;
  }

  .navbar-actions {
    gap: 4px;
  }

  .notification-button,
  .user-avatar {
    width: 36px;
    height: 36px;
  }

  .notifications-dropdown,
  .user-dropdown {
    width: 280px;
    right: -16px;
  }

  .search-results-popup {
    left: -12px;
    right: -12px;
  }
}

@media (max-width: 480px) {
  .medical-navbar {
    padding: 8px 12px;
  }

  .mobile-brand {
    gap: 12px;
  }

  .logo-background {
    width: 36px;
    height: 36px;
  }

  .hamburger-button {
    width: 36px;
    height: 36px;
  }

  .search-section {
    margin: 0 8px;
  }

  .search-input-wrapper {
    border-radius: 10px;
  }

  .search-input {
    padding: 10px 36px 10px 44px;
    font-size: 0.8rem;
  }

  .search-icon {
    left: 12px;
  }

  .clear-search {
    right: 12px;
  }

  .notification-button,
  .user-avatar {
    width: 32px;
    height: 32px;
  }

  .notifications-dropdown {
    width: calc(100vw - 24px);
    right: -12px;
  }

  .user-dropdown {
    width: calc(100vw - 24px);
    right: -12px;
  }

  .search-results-popup {
    left: -12px;
    right: -12px;
  }
}

/* Click outside to close functionality */
.navbar-wrapper {
  position: relative;
}

/* Animaciones suaves */
@media (prefers-reduced-motion: no-preference) {

  .hamburger-button,
  .search-input-wrapper,
  .notification-button,
  .user-button,
  .dropdown-item,
  .patient-result-item,
  .line {
    transition: all 0.2s ease;
  }
}
</style>